import { gql } from '@apollo/client';

export const GET_UPDATE_HISTORY = gql`
  query GetUpdateHistory {
    vm {
      enterpriseUpdateHistory {
        diffId
        diffType
        pushMode
        status
        entityType
        entityLabel
        rootName
        rootEntityType
        fieldPath
        fieldLabel
        itemName
        appliedValue
        replacedValue
        summary
        dateResolved
      }
    }
  }
`;
